module.exports = __webpack_public_path__ + "img/ESAKIP.3fc1084b.png";